import { LoanStatusExternal } from '@nemuru-eng/js-api-client';

export const loanStatusExternalValues = [
  LoanStatusExternal.INITIAL,
  LoanStatusExternal.ON_HOLD,
  LoanStatusExternal.APPROVED,
  LoanStatusExternal.CONFIRMED,
];
